<div class="new-generation-template">
  <span [wcCxJsonLd]="snippetImages()"></span>
  <span [wcCxJsonLd]="snippetVideos()"></span>

  <!-- DynamicBody slot -->
  <cx-page-slot position="DynamicBody" />

  <!-- SEO slot -->
  <cx-page-slot position="SEO" />
</div>
